export enum RythmeContratEnum {
    None = 0,
    QuatreSurSept = 1,
    CinqSurSept = 2,
    SeptSurSept = 3
}